<form
  *ngIf="!submitedForm"
  id="form"
  #formData="ngForm"
  (ngSubmit)="onSubmit($event, formData)"
  (formdata)="(formData)"
>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <input
          type="text"
          required
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="First Name*"
          name="firstName"
          ngModel
        />
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Last Name*"
          name="lastName"
          ngModel
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <input
          type="email"
          required
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Email*"
          name="email"
          ngModel
        />
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <input
          type="tel"
          required
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Phone Number*"
          name="phone"
          ngModel
        />
      </div>
    </div>
  </div>
  <div *ngIf="formType === 'general'" class="row">
    <div class="col">
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Prefered Contact Method"
          name="contactMethod"
          ngModel
        />
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Prefered Contact Time"
          name="contactTime"
          ngModel
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <textarea
          class="form-control"
          id="exampleFormControlTextarea1"
          rows="5"
          placeholder="Comments"
          name="message"
          ngModel
        ></textarea>
      </div>
    </div>
  </div>
  <div *ngIf="formType === 'career'" class="row">
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label for="exampleFormControlFile1"><b>Upload Resume:</b></label>
        <label for="exampleFormControlFile1"
          >Allowed file extensions: .pdf, .jpg, .png</label
        >
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="form-group">
        <div class="input-group custom-file-button">
          <input
            type="file"
            (change)="handleFileInput($event)"
            required
            class="form-control pl-0"
            id="inputGroupFile"
            name="document"
            ngModel
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <button type="submit" class="submit-button">Submit</button>
    </div>
  </div>
</form>

<div *ngIf="submitedForm">
  <h3>Thank you for sending us your info</h3>
</div>
